// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xs_a bho_a bho_x","StrollerDetailRating__muted":"xs_b bho_fi"};